import { useMutation } from '@apollo/client'
import { EditPriceVariables, EditCompany } from '../../types'
import { EDIT_DEFAULT_PRICE } from './operations'

interface Props {
  onCompleted?: () => void
}

export const useEditDefaultPrice = ({ onCompleted }: Props) =>
  useMutation<EditCompany, EditPriceVariables>(EDIT_DEFAULT_PRICE, { onCompleted })
